import SwiperSlider from "./abstract/SwiperSlider";
import $ from "jquery";

export default class Slideshow extends SwiperSlider {
  constructor(element, context) {
    super(element, context);

    this.options = {
      slidesPerView: 1,
      autoHeight: true,
      watchOverflow: false,
      spaceBetween: 0,
      loop: true,
      speed: $.browser.mobile ? 300 : 1000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      effect: $.browser.mobile ? 'slide' : 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    $(() => {
      if (this.element.find('.swiper-slide').length > 1) {
        this.init();
      } else {
        this.element.find('.swiper-slide').addClass('swiper-slide-active');
        this.element.find('.swiper-buttons').remove();
      }
    });
  }
}
